import { Typography } from "@circleco/compass/components/Typography";
import type { ReactNode } from "react";

import type { UpgradePreviewMoney } from "@/react/types/Paywalls/Checkout/UpgradePreview";

type UpgradeOrderRowVariant = "default" | "plan" | "total" | "discount";

export const UpgradeOrderRow = ({
  amount,
  detail,
  label,
  variant = "default",
}: {
  amount: UpgradePreviewMoney | null;
  detail?: ReactNode;
  label: ReactNode;
  variant?: UpgradeOrderRowVariant;
}) => {
  const isStrong = variant === "total";
  const isDiscount = variant === "discount";
  const textVariant = variant === "total" ? "heading-md" : "body-md";
  const labelColor = isStrong || variant === "plan" ? "primary" : "secondary";
  const amountColor = isDiscount ? "success" : labelColor;

  return (
    <div className="flex justify-between gap-4" data-testid="upgrade-order-row">
      <div>
        <Typography variant={textVariant} color={labelColor} component="div">
          {isStrong && typeof label === "string" ? (
            <strong>{label}</strong>
          ) : (
            label
          )}
        </Typography>
        {typeof detail === "string" ? (
          <Typography className="mt-1" variant="body-sm" color="secondary">
            {detail}
          </Typography>
        ) : (
          detail
        )}
      </div>
      {amount && (
        <Typography variant={textVariant} color={amountColor}>
          {isStrong ? <strong>{amount.formatted}</strong> : amount.formatted}
        </Typography>
      )}
    </div>
  );
};
